export default "__VITE_ASSET__DRq2RhCW__"